module.exports = __webpack_public_path__ + "media/react/pages/add_ons/assets/gmat_live_classes/erika-a6c176368aa3fe91c180c2e033c2afa9.png";